<template>
  <div>
    <router-view />
    <AppFooter />
  </div>
</template>

<script>
import AppFooter from '@/components/common/AppFooter.vue';

export default {
  name: "AuthLayout",
  components: {
    AppFooter,
  },
};
</script>

<style scoped>
/* Add any necessary styling here */
</style>